import { TextLink } from 'baby-design'
import { shippingConsolidationHelpPath } from 'lib/urls'
import css from './consolidated-shipping-subtext.styles.scss'

export default () => (
  <div className={css.ConsolidatedShippingSubtext}>
    <span>* Exclusions apply. </span>
    <TextLink
      underline
      href={shippingConsolidationHelpPath}
      innerContentClassName={css.ConsolidatedShippingSubtext__link}
      rel="noreferrer"
      size="sm"
      target="_blank"
    >
      Learn more
    </TextLink>
  </div>
)
